import { types } from '../../types/types';
import { startSpinner, finishSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";
import ContratacionesService from '../../services/ContratacionesService';
import { handleErrorApi } from '../../helpers/randoms';

export const desSeleccionarContrato = () => ({
  type: types.contratacionesContratoLimpiarSeleccion,
});

export const desSeleccionarPresupuesto = () => ({
  type: types.contratacionesPrespuestoXidClean,
});

export const cleanContratos = () => ({
  type: types.contratacionesContratosLimpiar,
});

export const setDataContrato = (dataContrato) => ({
  type: types.contratacionesSetDataContrato,
  payload: dataContrato
});

export const fetchTraerContratacionIngreso = (data) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.contratacionesTraerPorCUITStart })
  try {
    const response = await ContratacionesService.traerEfectorIngreo(data)
    const body = await response.json();
    if (response.ok) {
      data.nuevo=false
      const response2= await ContratacionesService.traerEfectorIngreo(data)
      const body2 = await response2.json();
      if(response2.ok && body2.length > 0){
        dispatch(startAlerta(`¡El número de CUIT ya posee contratos ingresados!`, 'warning'));
      }
      dispatch({
        type: types.contratacionesTraerPorCUITSuccess,
        payload: body[0],
      });
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    dispatch({ type: types.contratacionesTraerPorCUITError })
    handleErrorApi(dispatch, error, "Error al traer el contrato", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchTraerContratosEntreCods = (codDesde, codHasta) => async (dispatch) => {
  dispatch(startSpinner());
  dispatch({ type: types.contratacionesTraerContratosPorCodStart })
  try {
    const response = await ContratacionesService.traerEfectoresPorCods(codDesde, codHasta)
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesTraerContratosPorCodSuccess,
        payload: body,
      });
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    dispatch({ type: types.contratacionesTraerContratosPorCodError })
    handleErrorApi(dispatch, error, "Error al traer los contratos", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchTraerContratacionIngresoXPresupuesto = (id) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesService.traerEfectorPorId(id)
    const body = await response.json();
    if (response.ok) {
      dispatch(setDataContrato(body));
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al traer el contrato", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const contratacionesGuardarContrato = (data, setNuevo) => async (dispatch, getState) => {
  dispatch(startSpinner())
  try {
    let response = null
    data.idEfectorFacturacion=getState().contrataciones.dataContrato.idEfectorFacturacion
    if (data.idEfectorFacturacion === null) {
      response = await ContratacionesService.guardarEfectorFacturacion(data);
    } else {
      response = await ContratacionesService.actualizarEfectorFacturacion(data.idEfectorFacturacion, data);
    }
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGuardarContrato,
        payload: data.idEfectorFacturacion === null ? body : data
      });
      if(data.idEfectorFacturacion === null){
        setNuevo(false);
      }
      dispatch(finishSpinner())
      dispatch(startAlerta("Datos guardados correctamente", "success"))

    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al guardar un contrato", "Ha ocurrido un error. Intente nuevamente")
  }
};

export const fetchNomenclador = () => async (dispatch) => {
  dispatch(startSpinner())
  dispatch({ type: types.contratacionesNomencladorTraerStart })
  try {
    const result = await ContratacionesService.traerNomenclador()
    const body = await result.json()
    if (result.ok) {
      dispatch({
        type: types.contratacionesNomencladorTraerSuccess,
        payload: body
      })
      dispatch(finishSpinner())
    } else {
      throw body
    }
  } catch (error) {
      dispatch({ type: types.contratacionesNomencladorTraerError })
      dispatch(finishSpinner())
      handleErrorApi(dispatch, error, "Error al obtener nomenclador", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const fetchMatriculasMedicas = () => async (dispatch) => {
  dispatch(startSpinner())
  dispatch({ type: types.contratacionesMatriculasMedicasTraerStart })
  try {
    const result = await ContratacionesService.traerMatriculasTipo()
    const body = await result.json()
    if (result.ok) {
      dispatch({
        type: types.contratacionesMatriculasMedicasTraerSuccess,
        payload: body
      })
      dispatch(finishSpinner())
    } else {
      throw body
    }
  } catch (error) {
    dispatch({ type: types.contratacionesMatriculasMedicasTraerError })
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al obtener matriculas", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const fetchMotivosBaja = () => async (dispatch) => {
  dispatch(startSpinner())
  dispatch({ type: types.contratacionesMotivosBajaTraerStart })
  try {
    const result = await ContratacionesService.traerMotivosBajaEfector()
    const body = await result.json()
    if (result.ok) {
      dispatch({
        type: types.contratacionesMotivosBajaTraerSuccess,
        payload: body
      })
      dispatch(finishSpinner())
    } else {
      throw body
    }
  } catch (error) {
    dispatch({ type: types.contratacionesMotivosBajaTraerError })
    dispatch(finishSpinner())
    handleErrorApi(dispatch, error, "Error al obtener motivos de baja", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const setearPresupuestoContratos = (payload) => async (dispatch) => {
  dispatch({
    type: types.contratacionesPrespuestoXidSetear,
    payload
})
}

export const fetchPrepuestoContratos = (idPresupuesto, setIdPresupuesto) => async (dispatch) => {
  dispatch({ type: types.contratacionesPrespuestoXidTraerStart })
  try {
    const result = await ContratacionesService.traerPrespuesto(idPresupuesto)
    const body = await result.json()
    if (result.ok) {
      dispatch({
        type: types.contratacionesPrespuestoXidSetear,
        payload: body
      })
      setIdPresupuesto(0)
    } else {
      throw body
    }
  } catch (error) {
    dispatch({ type: types.contratacionesPrespuestoXidTraerError })
    handleErrorApi(dispatch, error, "Error al traer el presupuesto", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const fetchEfectorGestionMesa = (idEfectorFacturacion) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const result = await ContratacionesService.traerEfectorMesa(idEfectorFacturacion)
    const body = await result.json()
    if (result.ok) {
      setDataContrato(body);
      dispatch(finishSpinner());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(desSeleccionarContrato());
    handleErrorApi(dispatch, error, "Error al traer el contrato", "Ha ocurrido un error. Intente nuevamente")
  }
}